import { PipeTransform, Pipe } from '@angular/core';
import { TranslationService } from './../services/translation.service';

// Define a pipe for tranlation of the keys
@Pipe({ name: 'translate' })
export class TranslatePipe implements PipeTransform {

    constructor(private translationService: TranslationService) { }

    // Transform method to handle the pipe execution
    transform(key: string): string {
        return this.translationService.translate(key);
    }
}